/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, answerSelect, answerError } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBED : ANSWER TEXT 2 : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	text2: {
		position: 'relative',
		zIndex: '3',
		marginBottom: pxToEm(7),
		'& .background': {
			background: 'rgba(255,255,255,0.30)', // removed in animations for selected answer (so we don't have overlapping backgrounds)
			display: 'block',
			position: 'absolute',
			zIndex: '1',
			width: replacePXinStringWithEM('calc(100% + 40px)'),
			height: '100%',
			marginLeft: pxToEm(-20),
			transition: 'background .2s linear 0s',
			extend: answerSelect,
            '&.selected-false.valid-false': {
                extend: answerError.text
            }
		},
		'& .desc': {
			position: 'relative',
			zIndex: '2',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'flex-start',
			textAlign: 'left',
			height: pxToEm(36),
			width: '100%',
			color: '#fff',
			'& .icon': {
				background: 'rgba(255,255,255,0.20)', // gets removed from embed_styles when editable-true class applied because correct answer icon sits over top
				borderRadius: '100%',
				marginRight: pxToEm(7),
				width: pxToEm(10),
				height: pxToEm(10)
			},
			'& .text': {
				width: '100%',
				height: '100%',
				display: 'flex',
				alignItems: 'center'
			},
			'& .text.medium': {
				fontSize: pxToEm(14)
			},
			'& .text.standard': {
				fontSize: pxToEm(16)
			}
		},
		'&:hover': {
			'& .background': {
				background: 'rgba(255,255,255,0.50)'
			}
		}
	}
});